import React, { useMemo } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Progress } from "antd";
import i18n from "I18n";

import { enLocaleNumberFormatter } from "../../utils";
import "./LevelSectionV2.scss"
import { getLevelIndex } from "utils/LevelUtils";

const LevelSection = ({
  language,
  userName,
  levelConfig,
  renewDate,
  levelName,
  level,
  TPE,
  showLevelUpProgress,
  levelUpProgress,
  pointsToLevelUp,
}) => {
  const history = useHistory();
  const levelIndex = useMemo(() => {
    return getLevelIndex(level);
  }, [level]);

  return (
    <div className="profile-level-section">
      <div className={`level-section-content level-section-content-config level-${levelIndex}-color headline`}>
        <div className="d-flex level-section-header">
          <div>
            <div>{`${userName}`}</div>
            <div className="level-text body-3">{levelName}</div>
          </div>
          <div className="qrcode-icon" onClick={() => history.push("/user/myCard")}>
            <img alt="icon" src="/profile/level/qr-code.png" />
          </div>
        </div>
        {showLevelUpProgress &&
          <div className="d-flex flex-column">
            <div>
              <div className="subheading">{i18n.t("spend")}{i18n.t("HKD", { TPE: enLocaleNumberFormatter(pointsToLevelUp) })}</div>
              <div className="tag-menu-1">{i18n.t("toUpgrade", { nextLevelName: levelConfig[level]?.name })}</div>
            </div>
            <div>
              <Progress
                className="upgrade-progress"
                percent={levelUpProgress * 100}
                showInfo={false}
                strokeWidth={8}
              />
            </div>
            <div className="spend-to-upgrade tag-menu-1">
              {i18n.t("spent")}
              <p className="tag-menu-2">{i18n.t("HKD", { TPE: enLocaleNumberFormatter(TPE) })}</p>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  userName: state.users.displayName,
  levelConfig: state.users.levelConfig,
  renewDate: state.users.renewDate,
  levelName: state.users.levelName,
  level: state.users.level,
  TPE: state.users.TPE,
  showLevelUpProgress: state.users.showLevelUpProgress,
  levelUpProgress: state.users.levelUpProgress,
  pointsToLevelUp: state.users.pointsToLevelUp,
})

export default connect(mapStateToProps)(LevelSection);
